import { useEffect, useMemo } from "react"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import { getOrganizationId } from "reduxSlices/currentSettingsSlice"
import { setFilterSelections, settingsToPersist } from "reduxSlices/surveyRecipientTableSlice"
import { currentUserId as getCurrentUserId } from "reduxSlices/sessionSlice"
import { LocalStoragePersistence } from "utils/Persistence"

const SETTINGS_PERSISTENCE_PROPERTY = "settings"

const useSurveyRecipientsIndexSettings = ({ persistence = LocalStoragePersistence } = {}) => {
  const dispatch = useDispatch()

  const organizationId = useSelector(getOrganizationId)
  const currentUserId = useSelector(getCurrentUserId)
  const surveyRecipientSettingsToPersist = useSelector(settingsToPersist, isEqual)

  const key = useMemo(() => (
    `survey-recipients-index-settings-org-${organizationId}-user-${currentUserId}`
  ), [currentUserId, organizationId])

  // On load, get persisted filter/sort selections and pass them to redux
  useEffect(() => {
    const persistedSettings = persistence.lookup({ key, property: SETTINGS_PERSISTENCE_PROPERTY })

    dispatch(setFilterSelections(persistedSettings))
  }, [dispatch, key, persistence])

  // Keep filter/sort selections up to date in local storage
  useEffect(() => {
    persistence.persist({ key, property: SETTINGS_PERSISTENCE_PROPERTY, value: surveyRecipientSettingsToPersist })
  }, [surveyRecipientSettingsToPersist, key, persistence])
}

export default useSurveyRecipientsIndexSettings
